import { Link } from "gatsby"
import styled from "styled-components"

import { uiColorToBaseColor } from "styleguide/styles/colors"

export const Button = styled.button`
  border-radius: 32px;
  border-color: transparent;
  box-shadow: none;
  background-color: ${uiColorToBaseColor("red")};
  padding: 10px 35px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: white;
    background-color: ${uiColorToBaseColor("hoverRed")};
    text-decoration: none;
  }
`

export const ButtonOutlined = styled.button`
  border-radius: 32px;
  border-color: ${uiColorToBaseColor("darkerRed")};
  border-width: 2px;
  border-style: solid;
  box-shadow: none;
  background-color: transparent;
  padding: 10px 35px;
  color: ${uiColorToBaseColor("darkerRed")};
  font-weight: 500;
  cursor: pointer;

  &:hover {
    border-color: ${uiColorToBaseColor("red")};
  }
`

export const ButtonOutlinedLink = ButtonOutlined.withComponent("a")

export const ButtonOutlinedGatsbyLink = ButtonOutlined.withComponent(Link)

export const ButtonLink = Button.withComponent("a")

export const ButtonGatsbyLink = Button.withComponent(Link)

export const GithubButtonOutlined = styled(ButtonOutlinedLink)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  font-weight: 600;

  & > * {
    flex: 0 0 auto;
  }

  &:hover {
    text-decoration: none;
  }
`
